module.exports = __webpack_public_path__ + "img/tm_header_logo.65194ea9.svg";